import { NavLink } from "react-router-dom";
import { LayoutDashboard, Briefcase, Coins, ArrowLeftRight, Menu } from "lucide-react";
import { hapticTap } from "@/lib/haptics";

const TABS = [
    { to: "/app/dashboard", label: "Inicio", icon: LayoutDashboard, testid: "inicio" },
    { to: "/app/portfolios", label: "Carteras", icon: Briefcase, testid: "carteras" },
    { to: "/app/holdings", label: "Activos", icon: Coins, testid: "activos" },
    { to: "/app/transactions", label: "Movim.", icon: ArrowLeftRight, testid: "movim" },
];

// Native bottom tab bar. Renders only inside the app shell on native; "Mas" opens
// the existing drawer for secondary sections. Safe-area bottom inset via CSS.
// Min touch target: py-3 + icon + label reaches ~52px on most devices.
export default function BottomNav({ onMore }) {
    const base = "relative flex flex-col items-center justify-center gap-0.5 flex-1 min-h-[52px] py-3 text-[10px] font-medium transition-colors select-none";

    return (
        <nav
            className="bottom-nav fixed bottom-0 left-0 right-0 z-30 flex items-stretch bg-bone/96 backdrop-blur-sm border-t border-soft_border"
            data-testid="bottom-nav"
        >
            {TABS.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    onClick={() => hapticTap()}
                    className={({ isActive }) =>
                        `${base} ${isActive ? "text-petrol" : "text-soft_muted hover:text-graphite"}`
                    }
                    data-testid={`bottomnav-${t.testid}`}
                >
                    {({ isActive }) => (
                        <>
                            {isActive && (
                                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[2.5px] bg-petrol rounded-b-full" />
                            )}
                            <t.icon
                                className={`w-5 h-5 transition-transform ${isActive ? "scale-110" : ""}`}
                                strokeWidth={isActive ? 2 : 1.5}
                            />
                            {t.label}
                        </>
                    )}
                </NavLink>
            ))}
            <button
                onClick={() => { hapticTap(); onMore(); }}
                className={`${base} text-soft_muted hover:text-graphite`}
                data-testid="bottomnav-more"
            >
                <Menu className="w-5 h-5" strokeWidth={1.5} />
                Mas
            </button>
        </nav>
    );
}
